import { useParams } from 'react-router-dom';
import { FeatureLayout } from '@lendica/components';
import { useEffect, useState } from 'react';
import { usePayLaterApi } from '../payLaterAPI';
import { useCompanyNavigate } from '@lendica/hooks';
import { Box } from '@mui/material';
import { AgreeToTerms } from '@lendica/select-paylater-terms';

export const AgreeToTermsView = () => {
    const navigate = useCompanyNavigate();
    const api = usePayLaterApi();
    const [loading, setLoading] = useState(true);
    const [bill, setBill] = useState(null);
    const [selectedOffer, setSelectedOffer] = useState(null);
    const [approval, setApproval] = useState({});

    const { billId, offerId } = useParams();

    useEffect(() => {
        const getInvoiceDetails = async () => {
            setLoading(true);
            try {
                const res = await api.getOffers(billId);
                const offer = res.offers.findIndex(offer => offer?.id === offerId);
                setBill(res.bill);
                setSelectedOffer(res.offers[offer]);
                const approvalData = await api.getPaylaterApproval();
                setApproval(approvalData);
            } catch (e) {
            } finally {
                setLoading(false);
            }
        };
        getInvoiceDetails();
    }, []);

    const confirmDeal = async () => {
        try {
            const dealId = await api.initializeDeal(billId, offerId);
            navigate(`/paylater/bill/${billId}/terms/confirmation/${dealId}`);
        } catch (e) {
            navigate('/paylater/error');
            setLoading(false);
        }
    };

    return (
        <FeatureLayout loading={loading}>
            <Box
                sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    boxSizing: 'border-box',
                    width: '100%',
                    px: 4,
                    py: 2,
                }}
            >
                <AgreeToTerms
                    onAgree={confirmDeal}
                    onGoBack={() => navigate(`/paylater/bill/${billId}/terms/select/${offerId}`)}
                    bill={bill}
                    offer={selectedOffer}
                    approval={approval}
                />
            </Box>
        </FeatureLayout>
    );
};
